<form *dynamicFormInfo="formInfo" (keyup.enter)="search()">
  <div class="row">
    <div class="col-6">
      <app-generic-input controlName="employerNumber"></app-generic-input>
    </div>
  </div>
  <div class="row">
    <div class="col-3">
      <app-select-input
        #nameSearchOptionTypeList
        controlName="nameSearchOptionType"
        [showNullPlaceholder]="false"
      ></app-select-input>
    </div>
    <div class="col-4">
      <app-generic-input
        approvedNameCharacters
        controlName="name"
        [labelOverride]="FieldLabelConstants.EmployerName"
      ></app-generic-input>
    </div>
    <div class="col-5">
      <app-text-input
        controlName="fein"
        [maskConfig]="feinMaskConfig"
        (input)="onFeinChange()"
      ></app-text-input>
    </div>
  </div>
  <div class="row">
    <div class="col-6">
      <app-generic-input controlName="streetAddress"></app-generic-input>
    </div>
    <div class="col-6">
      <app-generic-input controlName="city"></app-generic-input>
    </div>
  </div>
</form>
